import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { DollarSign, Clock, Shield, Heart } from "lucide-react";

export function HostCTASection() {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 gradient-coral opacity-90" />
      <div className="absolute inset-0 bg-gradient-to-r from-coral/90 to-coral-dark/90" />
      
      <div className="container relative z-10">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ama pets? Ganhe uma renda extra!
          </h2>
          <p className="text-xl mb-8 text-white/90">
            Transforme seu amor por animais em uma oportunidade. Seja um anfitrião AllePets.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            {[
              { icon: DollarSign, label: "Até R$ 3.000/mês" },
              { icon: Clock, label: "Horários flexíveis" },
              { icon: Shield, label: "Seguro incluso" },
              { icon: Heart, label: "Faça o que ama" },
            ].map(({ icon: Icon, label }, i) => (
              <div key={i} className="bg-white/20 backdrop-blur-sm rounded-xl p-4">
                <Icon className="w-8 h-8 mx-auto mb-2" />
                <p className="text-sm font-medium">{label}</p>
              </div>
            ))}
          </div>

          <Button
            asChild
            size="lg"
            className="bg-white text-coral hover:bg-white/90 font-bold text-lg px-8 py-6 rounded-full"
          >
            <Link to="/anfitrioes">Começar agora</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
